import _URL from '../../URL/index';
const axios = _URL.axios;
const limit = 10

export default {
    services: {
        getDrivers: (branchId, token) => {
            return axios(token).get(`/dispatch/branches/${branchId}/drivers`)
        },
        getLastPositions: (drivers, token) => {
            return axios(token).post(`/dispatch/drivers/getLastPositions`, { drivers: drivers })
        }
    }
}